<template>
  <form @submit.prevent="handleSubmit" novalidate>
    <slot></slot>
  </form>
</template>

<script>
export default {
  name: 'VForm',
  props: {
    handleSubmit: {
      type: Function,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// VForm.vue?192c0b07